<div class="chart-wrapper d-flex justify-content-center align-items-center p-0 m-auto">
    <ejs-accumulationchart id="donut-container" align="center" [legendSettings]="legendSettings" [tooltip]="tooltip"
        (load)="load($event)" [enableBorderOnMouseMove]="false" (pointRender)="onPointRender($event)">
        <e-accumulation-series-collection>
            <e-accumulation-series name="Revenue" [dataSource]="data" xName="x" [startAngle]="startAngle" yName="y"
                [radius]="radius" [innerRadius]="innerRadius" [dataLabel]="dataLabel" [palettes]="colorPalettes">
            </e-accumulation-series>
        </e-accumulation-series-collection>
    </ejs-accumulationchart>
</div>